import { Grid, Switch } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CenteredLoading } from 'components/CenteredLoading';
import { useParams } from 'react-router-dom';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';
import { useGroup } from 'hooks/api/useGroups';
import { FormSwitch } from 'components/Form/FormSwitch';
import { useForm } from '@mantine/form';
import { queryKeys } from 'utils/query';
import { updateGroupConfiguration } from 'services/configuration';
import { useCustomMutation } from 'hooks/api/useCustomMutation';

export const ModulesSettingsForm = () => {
  const { t } = useTranslation();
  const { groupId } = useParams<{ groupId: string }>();
  const { data, isLoading } = useGroup(groupId);
  const { mutate: updateValues } = useCustomMutation({
    fn: updateGroupConfiguration,
    onSuccess: { invalidateQueryKeys: [[queryKeys.groupData, groupId]] },
  });

  const form = useForm({
    mode: 'controlled',
    initialValues: { id: data?.id, patientConfiguration: data?.patientConfiguration },
    onValuesChange: (values) => {
      updateValues(values);
    },
  });

  if (isLoading) return <CenteredLoading />;

  const [onLabel, offLabel] = [t('label_on').toUpperCase(), t('label_off').toUpperCase()];

  return (
    <form>
      <PaperHeader titleKey={'group_modules_title'} iconKey={'groupsettings_general_modules_tooltip'} />
      <Grid mt={20}>
        <FormSwitch label={t('patients_tab_weight')}>
          <Switch
            {...form.getInputProps('patientConfiguration.weightBmi.enabled', { type: 'checkbox' })}
            disabled={true}
            onLabel={onLabel}
            offLabel={offLabel}
          />
        </FormSwitch>
        <FormSwitch label={t('blood_pressure_label')}>
          <Switch
            {...form.getInputProps('patientConfiguration.bloodPressure.enabled', { type: 'checkbox' })}
            disabled={true}
            onLabel={onLabel}
            offLabel={offLabel}
          />
        </FormSwitch>
      </Grid>
    </form>
  );
};
